import { Link } from "@tanstack/react-router"
import { LuCalendar, LuHouse, LuLayoutGrid, LuMessageSquare, LuUser } from "react-icons/lu"
import { cn } from "~/lib/utils"

export type TabId = "feed" | "catalog" | "chat" | "calendar" | "profile"

const tabs = [
  { id: "feed", label: "Лента", icon: LuHouse },
  { id: "catalog", label: "Каталог", icon: LuLayoutGrid },
  { id: "chat", label: "Чат", icon: LuMessageSquare },
  { id: "calendar", label: "Календарь", icon: LuCalendar },
  { id: "profile", label: "Профиль", icon: LuUser },
] as const

interface BottomNavProps {
  activeTab: TabId
}

export function BottomNav({ activeTab }: BottomNavProps) {
  return (
    <>
      <div aria-hidden className="h-bottom-nav shrink-0" />
      <nav className="fixed bottom-0 inset-x-0 z-40 flex items-center justify-around bg-card border-t border-primary/20 px-s pt-s pb-safe-ios-s">
        {tabs.map(({ id, label, icon: Icon }) => (
          <Link
            key={id}
            to="/"
            search={{ tab: id }}
            resetScroll={false}
            className={cn(
              "flex-1 flex flex-col items-center gap-xs py-xs",
              activeTab === id ? "text-primary" : "text-secondary-foreground",
            )}
          >
            <Icon className="size-icon-m" />
            <span className="text-[11px] font-black uppercase">{label}</span>
          </Link>
        ))}
      </nav>
    </>
  )
}
